import { render, staticRenderFns } from "./longloading_badage.vue?vue&type=template&id=4cd9c47b&scoped=true&"
import script from "./longloading_badage.vue?vue&type=script&lang=js&"
export * from "./longloading_badage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9c47b",
  null
  
)

export default component.exports